import ProxView from "./ProxyView";
import MainLayout from "./MainLayout";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Home";
import { DeviceListProvider } from "./provider/DeviceListProvider";
import { ThemeProvider } from "../context/ThemeContext";
import { UserProvider } from "./provider/UserAuthProvider";
import BaiduAnalytics from "./BaiduAnalytics";
import LoginCallbackPage from "./LoginCallbackPage";
import { LangProvider } from "../context/LangContext";

function FSendApp() {
  return (
    <>
      <BaiduAnalytics />
      <ThemeProvider>
        <LangProvider>
          <UserProvider>
            <DeviceListProvider>
              <BrowserRouter>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <MainLayout>
                        <Home />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/device/:deviceId"
                    element={
                      <MainLayout topBarShowBottomLine={true}>
                        <ProxView />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/login_callback"
                    element={
                      <MainLayout>
                        <LoginCallbackPage />
                      </MainLayout>
                    }
                  />
                </Routes>
              </BrowserRouter>
            </DeviceListProvider>
          </UserProvider>
        </LangProvider>
      </ThemeProvider>
    </>
  );
}

export default FSendApp;
